/**
 * Merges new source IDs into an existing comma-separated `qsource_suggestions`
 * param value, deduplicating entries.
 *
 * @param existing - The current param value (comma-separated string or undefined)
 * @param newSources - Source IDs to append
 * @returns The merged comma-separated string
 */
export function mergeSourceSuggestionParam(existing, newSources) {
    const existingSources = existing ? existing.split(',').filter(Boolean) : [];
    const merged = [...new Set([...existingSources, ...newSources])];
    return merged.join(',');
}
//# sourceMappingURL=mergeSourceSuggestionParam.js.map